<template>
  <div class="terms container">
    <b-row>
      <b-col md="10" offset-md="1">
        <h2 class="custom-title mt-5">Funding - Frequently asked questions</h2>
        <HideableParagraph :text="fundingFAQsParagraph" :is-hideable="false" />
        <HideableParagraph
          v-for="(block, idx) in fundingFAQsInformation"
          :key="idx"
          :title="block.title"
          :text="block.text"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { fundingFAQsParagraph, fundingFAQsInformation } from './constant';
import HideableParagraph from '@/components/HideableParagraph';

export default {
  name: 'FAQPage',

  components: {
    HideableParagraph
  },

  data() {
    return {
      fundingFAQsParagraph,
      fundingFAQsInformation
    };
  },

  head: {
    title: 'FAQs | Found',
    meta: [
      {
        hid: 'description',
        name: 'description',
        content: 'FAQ Description'
      }
    ]
  }
};
</script>
